import { Controller } from "@hotwired/stimulus"
import { isElementVerticallyContainedIn } from "../src/dom"

export default class extends Controller {

  // Lifecycle

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) { return }

    this.openHandler = this.repositionDropdown.bind(this)
    this.element.addEventListener("show.bs.dropdown", this.openHandler)
  }

  disconnect() {
    this.element.removeEventListener("show.bs.dropdown", this.openHandler)
  }

  // Actions

  repositionDropdown(event) {
    const dropdownMenu = event.target.querySelector(".dropdown-menu")
    if (!dropdownMenu) { return }

    const parent = event.target.closest(".card") || document.body

    if (isElementVerticallyContainedIn(dropdownMenu, parent)) { return }

    dropdownMenu.classList.add("dropdown-menu-upwards")
  }
}
